import {
  API_LOAN_GET_LOAN_TRADE,
  API_LOAN_GET_SHIPPING_INFO,
  API_LOAN_GET_SHIPPING_INFO_LOG,
  API_LOAN_SETPOINT,
  API_LOAN_SETPOINT_DILIGENCE,
  API_LOAN_SETPOINT_DOCUMENTS,
  API_LOAN_SETPOINT_DOCUMENTS_SEND,
  API_LOAN_SETPOINT_FACILITIES,
  API_LOAN_SETPOINT_PUSH,
  API_LOAN_UPDATE_SHIPPING_INFO,
  API_POST_CLOSING_DOCS,
  API_POST_CLOSING_FIELDS,
  API_POST_CLOSING_FIELDS_LOG,
  API_PURCHASE_ADVICE_DATA,
  API_PURCHASE_ADVICE_LOG,
  API_PURCHASE_ADVICE_SELLER_CANCEL_SIGN_BY_ID,
  API_PURCHASE_ADVICE_SELLER_DATA,
  API_PURCHASE_ADVICE_SELLER_LOG,
  API_PURCHASE_ADVICE_SELLER_SIGN,
  API_PURCHASE_ADVICE_SELLER_SIGN_BY_ID,
  API_SHIPPING_INFO_HEADER,
  API_SHIPPING_INFO_HEADER_LOG,
} from 'config'
import Api from 'services/api'

import { downloadFile } from '../documents'

export const updatePostClosingFields = (menu: string, loanFields: Record<string, any>) => {
  return Api.put(API_POST_CLOSING_FIELDS, loanFields, { menu })
}

export const getPostClosingFields = (menu: string) => {
  return Api.get(API_POST_CLOSING_FIELDS, {}, { menu })
}

export const downloadPostClosingDocs = async (loanNumber: number, entity: string) => {
  const response: Blob = await Api.get(
    API_POST_CLOSING_DOCS,
    { entity },
    {},
    {
      responseType: 'blob',
    },
  )

  downloadFile(`PostClosing - ${loanNumber}.zip`, response)
}

export const getPurchaseAdviceData = () => {
  return Api.get(API_PURCHASE_ADVICE_DATA)
}

export const postPurchaseAdviceDate = (data: Record<string, any>) => {
  return Api.post(API_PURCHASE_ADVICE_DATA, data)
}

export const getPurchaseAdviceLogs = (type: string, key: string) => {
  return Api.get(API_PURCHASE_ADVICE_LOG, {}, { type, key })
}

export const sendPurchaseAdviceDataToAccounting = (type: 'info' | 'sweepInfo' = 'info') => {
  return Api.post(`${API_PURCHASE_ADVICE_DATA}/accounting`, { type })
}

export const getPurchaseAdviceSellerData = () => {
  return Api.get(API_PURCHASE_ADVICE_SELLER_DATA)
}

export const postPurchaseAdviceSellerData = (data: Record<string, any>) => {
  return Api.post(API_PURCHASE_ADVICE_SELLER_DATA, data)
}

export const getPurchaseAdviceSellerLogs = (type: string, key: string) => {
  return Api.get(API_PURCHASE_ADVICE_SELLER_LOG, {}, { type, key })
}

export const sendPurchaseAdviceSignRequest = (data: Record<string, any>) => {
  return Api.post(API_PURCHASE_ADVICE_SELLER_SIGN, data)
}

export const cancelPurchaseAdviceSignRequest = (id: string) => {
  return Api.get(API_PURCHASE_ADVICE_SELLER_CANCEL_SIGN_BY_ID, {}, { id })
}

export const getPurchaseAdviceSellerSignData = (id: string) => {
  return Api.get(API_PURCHASE_ADVICE_SELLER_SIGN_BY_ID, {}, { id })
}

export const signPurchaseAdviceSellerData = (id: string) => {
  return Api.post(API_PURCHASE_ADVICE_SELLER_SIGN_BY_ID, {}, { id }, { timeout: 150000 })
}

export const getShippingInfo = () => {
  return Api.get(API_LOAN_GET_SHIPPING_INFO, {})
}

export const updateShippingInfo = (data: Record<string, any>) => {
  return Api.post(API_LOAN_UPDATE_SHIPPING_INFO, data)
}

export const getShippingInfoLogs = (key: string) => {
  return Api.get(API_LOAN_GET_SHIPPING_INFO_LOG, {}, { key })
}

/** Rename one Shipping Information section header (requires `Loan.Servicing.ShippingInformation.Header`). */
export const setShippingInfoHeader = (sectionKey: string, title: string) => {
  return Api.post(API_SHIPPING_INFO_HEADER, { title }, { sectionKey })
}

/** Audit log entries for a Shipping Information section header rename. */
export const getShippingInfoHeaderLog = (sectionKey: string) => {
  return Api.get(API_SHIPPING_INFO_HEADER_LOG, {}, { sectionKey })
}

export const getLoanTrade = () => {
  return Api.get(API_LOAN_GET_LOAN_TRADE)
}

export const updateLoanTrade = (data: Record<string, any>) => {
  return Api.put(API_LOAN_GET_LOAN_TRADE, data)
}

export const getCollateralReviewLogs = (menu: string, fieldName: string) => {
  return Api.get(API_POST_CLOSING_FIELDS_LOG, {}, { menu, fieldName })
}

export const pushSetpoint = (facilityGlobalId: string) => {
  return Api.post(API_LOAN_SETPOINT_PUSH, { facilityGlobalId })
}

export const getSetpointDiligence = () => {
  return Api.get(API_LOAN_SETPOINT_DILIGENCE)
}

export const getSetpointFacilities = () => {
  return Api.get(API_LOAN_SETPOINT_FACILITIES)
}

export const getSetpointRecord = () => {
  return Api.get(API_LOAN_SETPOINT)
}

export const saveSetpointDocuments = (documents: any[]) => {
  return Api.put(API_LOAN_SETPOINT_DOCUMENTS, { documents })
}

export const sendSetpointDocuments = () => {
  return Api.post(API_LOAN_SETPOINT_DOCUMENTS_SEND)
}
